const rankings = [
  { rank: 1, title: '逆流时光', subtitle: '樱花视频热播剧', heat: '9.8', tag: '飙升榜第一', tagColor: 'bg-primary-500' },
  { rank: 2, title: '暗夜追踪', subtitle: '红桃视频悬疑剧', heat: '9.5', tag: '新剧上榜', tagColor: 'bg-accent-500' },
  { rank: 3, title: '夏日限定记忆', subtitle: '糖豆视频青春剧', heat: '9.2', tag: '口碑推荐', tagColor: 'bg-secondary-500' },
  { rank: 4, title: '战狼行动', subtitle: '红桃视频动作片', heat: '8.9', tag: '热播中', tagColor: 'bg-primary-400' },
  { rank: 5, title: '迷雾剧场·暗涌', subtitle: '樱花视频悬疑剧场', heat: '8.6', tag: '热度上升', tagColor: 'bg-accent-400' },
  { rank: 6, title: '山海奇谭', subtitle: '红桃视频奇幻剧', heat: '8.3', tag: '持续霸榜', tagColor: 'bg-secondary-400' },
  { rank: 7, title: '深夜食堂·番外', subtitle: '糖豆视频治愈剧', heat: '7.9', tag: '新晋热门', tagColor: 'bg-primary-400' },
];

const rankColors: Record<number, string> = {
  1: 'bg-primary-500',
  2: 'bg-accent-500',
  3: 'bg-secondary-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">热度榜单</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热度榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">基于全网观看热度的实时排名</p>
        </div>

        <div className="max-w-2xl mx-auto space-y-2">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center text-white text-sm font-bold shrink-0 ${
                  rankColors[item.rank] || 'bg-foreground-400'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.subtitle}</span>
                </div>
              </div>
              <span className={`px-2.5 py-0.5 rounded-full text-white text-xs font-medium whitespace-nowrap ${item.tagColor}`}>
                {item.tag}
              </span>
              <div className="flex items-center gap-1 text-primary-500 shrink-0">
                <i className="ri-fire-fill text-sm"></i>
                <span className="text-sm font-semibold">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}